import { Card, Container, Section } from '@resolute/ui';
import { Compass, HeartHandshake, Rocket, ShieldCheck, type LucideIcon } from 'lucide-react';


import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';

const VALUES: { icon: LucideIcon; title: string; body: string }[] = [
  {
    icon: ShieldCheck,
    title: 'Transparency first',
    body: 'We verify before we publish, and we tell buyers the truth even when it costs us a deal. That standard applies internally too.',
  },
  {
    icon: Rocket,
    title: 'Ownership, fast',
    body: "We're a growing team — you'll own real outcomes early, not just tasks, with the support to move quickly and learn on the job.",
  },
  {
    icon: HeartHandshake,
    title: 'Customers over targets',
    body: 'Every role, from sales to legal, is measured on whether a buyer or investor actually had a good experience — not just on closed numbers.',
  },
  {
    icon: Compass,
    title: 'Growth corridors, not just deals',
    body: "We're building the category-defining platform for Gujarat's fastest-growing markets — there's a lot of ground still to cover.",
  },
];

export function CareersCulture() {
  return (
    <Section spacing="md">
      <Container>
        <Reveal className="max-w-2xl">
          <p className="text-sm font-medium uppercase tracking-widest text-secondary">
            Why work with us
          </p>
          <h2 className="mt-2 text-balance font-display text-display-sm font-semibold tracking-tight">
            Built by people who&apos;d rather be right than loud.
          </h2>
        </Reveal>

        <StaggerGroup className="mt-10 grid grid-cols-1 gap-5 sm:mt-12 sm:grid-cols-2">
          {VALUES.map(({ icon: Icon, title, body }) => (
            <StaggerItem key={title}>
              <Card className="flex h-full flex-col gap-3 p-6">
                <span className="flex size-10 items-center justify-center rounded bg-primary/10 text-primary">
                  <Icon className="size-5" aria-hidden="true" />
                </span>
                <h3 className="text-lg font-semibold tracking-tight">{title}</h3>
                <p className="text-sm text-muted-foreground">{body}</p>
              </Card>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </Container>
    </Section>
  );
}
